/**
 * ParkingPayment API
 *
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ScheduleFrequency } from './scheduleFrequency';
import { ScheduleReport } from './scheduleReport';


export interface UpdateReportScheduleDto { 
    id?: number;
    name: string;
    isActive?: boolean;
    frequencyType: ScheduleFrequency;
    dayOfWeek?: number | null;
    dayOfMonth?: number | null;
    customDate?: string | null;
    sendTime?: string | null;
    reports: ScheduleReport;
    userIds: Array<number>;
    locationId: number;
}
export namespace UpdateReportScheduleDto {
}


